import React, { useCallback } from 'react';

import { FeatureGroupHeaderRow } from './feature-group-header-row/feature-group-header-row';
import style from './feature-group-section.module.css';
import { FeatureRow } from './feature-row/feature-row';

/**
 * @typedef {import('../../new-lineup-plan-grid-types.d.ts').FeatureGroup} FeatureGroup
 */

/**
 * @typedef {import('../../../../../../../prop-types/subscription-data-types.d.ts').BillingPlan} BillingPlan
 */

/**
 * @param {object} props
 * @param {string} props.currentPlanId
 * @param {FeatureGroup} props.featureGroup
 * @param {boolean} props.isExpanded
 * @param {boolean} props.isLastSection
 * @param {(category: string) => void} props.onToggle
 * @param {BillingPlan[]} props.plans
 * @param {string} props.selectedPlanId
 * @returns {React.JSX.Element}
 */
export const FeatureGroupSection = ({ currentPlanId, featureGroup, isExpanded, isLastSection, onToggle, plans, selectedPlanId }) => {
  const { featureGroupId, features, featureGroupNameMessageDescriptor } = featureGroup;

  const toggleIsExpanded = useCallback(() => {
    onToggle(featureGroupId);
  }, [featureGroupId, onToggle]);

  return (
    <div className={style['feature-group-section']}>
      <FeatureGroupHeaderRow
        currentPlanId={currentPlanId}
        isExpanded={isExpanded}
        isLastSection={isLastSection}
        plans={plans}
        sectionTitleMessageDescriptor={featureGroupNameMessageDescriptor}
        selectedPlanId={selectedPlanId}
        toggleIsExpanded={toggleIsExpanded}
      />
      {isExpanded
        ? features.map((feature, index) => (
            <FeatureRow
              key={feature.featureNameMessageDescriptor.id}
              currentPlanId={currentPlanId}
              feature={feature}
              isLastRow={index === features.length - 1}
              isLastSection={isLastSection}
              selectedPlanId={selectedPlanId}
            />
          ))
        : null}
    </div>
  );
};
